import { IconEye, IconLock } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface AccessBadgeProps {
    /** The caller's access when it is below `manage`. */
    level: 'view' | 'none';
}

/** Text badge for a page header: "View only" or "No access". */
export default function AccessBadge({ level }: AccessBadgeProps) {
    const { t } = useTranslation('projects');
    const Icon = level === 'view' ? IconEye : IconLock;

    return (
        <span className="inline-flex items-center gap-1 shrink-0 px-1.5 py-0.5 rounded-sm border-[0.5px] border-line text-xs font-medium text-fg/78">
            <Icon size={14} aria-hidden="true" />
            {level === 'view' ? t('resource.viewOnly') : t('resource.noAccess')}
        </span>
    );
}
